// create modal for refill order
import React from "react";
import {
  Modal,
  Button,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
} from "react-bootstrap";

class RefillOrderModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quantity: 1,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
  };

  render() {
    const { show, handleClose, medicineName, medicineCode } = this.props;
    const medicineLabel = [medicineName, medicineCode]
      .filter(Boolean)
      .join(" - ");

    return (
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            Refill Request{medicineLabel ? ` - (${medicineLabel})` : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup key={this.props.index} className="mb-3">
            <ControlLabel>
              {" "}
              <span style={{ fontSize: "12px" }}>💊 </span>QUANTITY
            </ControlLabel>
            <FormControl
              type="number"
              value={this.props.refillQuantity}
              onChange={(e) => {
                const value = Number(e.target.value);
                if (!Number.isFinite(value) || value < 0) return;
                this.props.handleRefillQuantityChange(this.props.index, e);
              }}
              onKeyDown={(e) => {
                if (["-", "+", "e", "E"].includes(e.key)) e.preventDefault();
              }}
              onWheel={(e) => e.target.blur()}
              min={0}
              onPaste={(e) => {
                const value = Number(e.clipboardData.getData("text"));
                if (!Number.isFinite(value) || value < 0) e.preventDefault();
              }}
            />

            {this.props.refillQuantityError}
          </FormGroup>
          <FormGroup key={this.props.index}>
            <ControlLabel>
              <span style={{ fontSize: "12px" }}>💊 </span>REMARK
            </ControlLabel>
            <FormControl
              componentClass="textarea"
              style={{ marginLeft: "5px" }}
              rows={3}
              value={this.props.refillRemarks}
              onChange={(e) =>
                this.props.handleRefillRemarksChange(this.props.index, e)
              }
            />

            {this.props.refillRemarksError}
          </FormGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="fl_mb_web_1 btn-fill fl_mb_1 w_100 btn btn-danger"
          >
            Close
          </Button>
          <Button
            className="fl_mb_web_1 btn-fill fl_mb_1 w_100 btn btn-success"
            variant="primary"
            disabled={this.props.isSubmitting}
            onClick={() =>
              this.props.handleRefillRequestSubmit(this.props.index)
            }
          >
            {this.props.isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RefillOrderModal;
